var map = {
	"./attribution-fraud.gif": "0Ci6",
	"./install-attribution-fraud.gif": "yFNc",
	"./install-fraud.gif": "AHsi",
	"./lead-gen-fraud.gif": "GA7J",
	"./mobile-click-flooding.gif": "OiL5",
	"./mobile-click-injection.gif": "gx9E",
	"./mobile-click-spoofing.gif": "p2Na",
	"./mobile-device-id-reset-marathons.gif": "EcmW",
	"./mobile-inauthentic-engagement.gif": "jQbZ",
	"./mobile-incentivized-traffic.gif": "A7Mk",
	"./mobile-install-farms.gif": "P2XH",
	"./mobile-malvertising.gif": "/GmK",
	"./mobile-proxy-tunneling.gif": "TJda",
	"./web-bot-fraud.gif": "hP20",
	"./web-click-spoofing.gif": "vm08",
	"./web-device-spoofing.gif": "u5fC",
	"./web-hidden-landing-pages.gif": "sP23",
	"./web-image-embedding.gif": "Jt75",
	"./web-incentivized-traffic.gif": "uvtb",
	"./web-malvertising.gif": "BQwz",
	"./web-recycled-stolen-information.gif": "azNJ",
	"./web-sneaky-redirects.gif": "m8qF",
	"./web-toolbar-injection.gif": "5wA6",
	"./web-unapproved-network-syndication.gif": "nFPg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "q8gZ";